/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Section_FreezeInputs */

const fr_membership_section_freeze = /** @type {(inputs: Membership_Section_FreezeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause d'abonnement`)
};

/**

* @param {Membership_Section_FreezeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_section_freeze = /** @type {((inputs?: Membership_Section_FreezeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Section_FreezeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_section_freeze(inputs)
});